import { createSelector } from 'reselect';

export const getReportOptions = createSelector(
  state => state.reports.options,
  (_, resource, resourceId) => [resource, resourceId],
  (options, path) => options?.getIn(path)?.toJSON(),
);
